import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const TutorChatTokenHandler = {
  name: "TutorChatTokenHandler",
  getTctToken: function (ticket) {
    var token_ = "";
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMInner/GetTctekToken",
      type: "get",
      async: false,
      data: {
        ticket
      },
      dataType: "json",
      success: function (data) {
        token_ = data;
      }
    });
    return token_;
  },
};



// WEBPACK FOOTER //
// ./src/handler/TutorChatTokenHandler.js